"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerControllers = void 0;
var React = require("react");
var _1 = require("./");
var PodcastPlayerControllers = function (_a) {
    var podcastLink = _a.podcastLink, audioRef = _a.audioRef, isMobile = _a.isMobile;
    return (React.createElement("div", { className: "podcast-player-controllers flex justify-center tablet:w-full tablet:justify-end" },
        React.createElement("ul", { className: "podcast-player-controllers__list flex items-center list-none m-0" },
            React.createElement("li", { className: "podcast-player-controllers__item" },
                React.createElement(_1.PodcastPlayerVolume, { audioRef: audioRef, isMobile: isMobile })),
            React.createElement("li", { className: "podcast-player-controllers__item" },
                React.createElement(_1.PodcastPlayerSpeed, { audioRef: audioRef, isMobile: isMobile })),
            React.createElement("li", { className: "podcast-player-controllers__item" },
                React.createElement(_1.PodcastPlayerPodBeanLink, { src: podcastLink })))));
};
exports.PodcastPlayerControllers = PodcastPlayerControllers;
